import { render, staticRenderFns } from "./BottomAlert.vue?vue&type=template&id=e864dc7e&"
import script from "./BottomAlert.vue?vue&type=script&lang=js&"
export * from "./BottomAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports